import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Fragment from 'vue-fragment'
import naver from 'vue-naver-maps'

Vue.use(naver, {
  clientID: process.env.VUE_APP_NAVER_MAP_KEY,
  useOpenAPI: true
})
Vue.use(Fragment.Plugin)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
